import React, { Component } from 'react';

class DGROpenCamera extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DGRType: 'web'
    };
  }

  componentDidMount() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Detect iOS WebView
    if (/iPhone|iPad|iPod/.test(userAgent) && !window.MSStream) {
      this.setState({
        DGRType: 'app'
      });
    }

    // Detect Android WebView
    if (userAgent.includes('wv') || userAgent.includes('Android')) {
      this.setState({
        DGRType: 'app'
      });
    }
  }

  render() {
    const { onOpenDgr } = this.props;
    const { DGRType } = this.state;
    return (
      <div
        className="modal fade theme-modal" id="DGROpenCameraModal"
        tabIndex="-1" aria-labelledby="DGROpenCameraModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title">OPtimize</h5>
              {
                DGRType === 'web'
                  ? (
                    <p>Do you want to upload file?</p>
                  ) : (
                    <p>Do you want to open camera?</p>
                  )
              }
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal">No</button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-gray w-100"
                    data-bs-dismiss="modal"
                    onClick={() => onOpenDgr()}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DGROpenCamera;
